import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [apptId, setApptId] = useState(null);
  useEffect(() => {
    const sid = sp.get("session_id");
    if (!sid) return setStatus("error");
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setApptId(data.appointment_id);
        if (data.payment_status === "paid") setStatus("paid");
        else if (tries < 8) setTimeout(poll, 1500);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sp]);

  return (
    <div className="max-w-lg mx-auto text-center py-16">
      <div className="w-16 h-16 rounded-full bg-[#eaf7f0] text-[#3daa6e] flex items-center justify-center mx-auto mb-6"><CheckCircle2 size={32}/></div>
      <h1 className="cm-h2" data-testid="pay-success-title">Payment {status === "paid" ? "confirmed" : status === "pending" ? "processing" : status}</h1>
      <p className="cm-body mt-3 text-sm">
        {status === "paid" && "Your appointment is confirmed. We've saved everything to your dashboard."}
        {status === "checking" && "Please hold while we confirm your payment…"}
        {status === "pending" && "It's taking a little longer than usual — refresh in a moment."}
        {status === "error" && "We couldn't verify this payment. Please contact support."}
      </p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/patient/appointments" className="cm-btn-primary" data-testid="pay-success-appts">View my appointments</Link>
        {apptId && <Link to={`/patient/video/${apptId}`} className="cm-btn-outline" data-testid="pay-success-join">Prepare for consult</Link>}
      </div>
    </div>
  );
}
